var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showBanner
    ? _c("div", { attrs: { id: "custom-consent-blackbar" } }, [
        _c("div", { attrs: { id: "custom-truste-consent-track" } }, [
          _c(
            "div",
            {
              staticClass: "custom-truste-banner",
              attrs: { id: "custom-truste-consent-content" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "custom-truste-messageColumn",
                  attrs: { id: "custom-truste-consent-text" }
                },
                [_vm._v("\n        " + _vm._s(_vm.message) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "custom-close-btn",
                  on: { click: _vm.closeBanner }
                },
                [_vm._v("X")]
              )
            ]
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }